import React, { Component } from 'react';
import moment from 'moment';
import _ from 'lodash';

export default class DriversDashboardTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      drivers: props.drivers || null,
      isLoading: !props.drivers,
      url: props.url || null,
    };

    this._isMounted = false;
    this.handleAddOrderByInUser = this.handleAddOrderByInUser.bind(this);
  }

  componentDidMount() {
    this._isMounted = true;
    this.initializeEchoListener();

    if (this.state.isLoading) {
      this.getDrivers().then((drivers) => {
        if (Array.isArray(drivers)) {
          const prioritisedDrivers = drivers.map((user) =>
            this.handleAddOrderByInUser(user)
          );
          this.setState({
            drivers: _.orderBy(prioritisedDrivers, 'last_job_scheduled_dropoff_date', 'asc'),
          });
        }
      });
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
    Echo.leaveChannel('driver-scheduled-list-update');
  }

  initializeEchoListener() {
    Echo.channel('driver-scheduled-list-update').listen('DriverScheduledListUpdate', (e) => {
      if (e.driverId) {
        this.handleDriverUpdate(e.driverId);
      } else if (e.jobId) {
        this.handleJobRemoval(e.jobId);
      }
    });
  }

  async handleDriverUpdate(driverId) {
    if (!this.state.url) return;

    const response = await fetch(this.state.url, {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + window.api_token,
        Accept: 'application/json',
      },
    });

    const responseData = await response.json();

    if (this._isMounted) {
      const updatedDrivers = responseData.map((user) => this.handleAddOrderByInUser(user));
      this.setState({
        drivers: _.orderBy(updatedDrivers, 'last_job_scheduled_dropoff_date', 'asc'),
        isLoading: false,
      });
    }
  }

  handleJobRemoval(jobId) {
    if (this.state.jobs && this.state.jobs.length > 0) {
      const updatedJobs = this.state.jobs.filter((job) => job.id !== jobId);
      this.setState({ jobs: updatedJobs });
    }
  }

  async getDrivers() {
    if (!this.state.url) return;

    const response = await fetch(this.state.url, {
      method: 'GET',
      mode: 'cors',
      cache: 'no-cache',
      credentials: 'same-origin',
      headers: {
        Authorization: 'Bearer ' + window.api_token,
        Accept: 'application/json',
      },
    });

    const responseData = await response.json();

    if (this._isMounted) {
      this.setState({
        drivers: responseData || [],
        isLoading: false,
      });
    }

    return responseData;
  }

  handleAddOrderByInUser(user) {
    if (user?.driver) {
      const lastJobOfDriver = user.driver.jobs ? _.last(user.driver.jobs) : null;
      user['last_job_scheduled_dropoff_date'] = lastJobOfDriver
        ? moment(lastJobOfDriver.scheduled_dropoff_date).format('YYYY-MM-DD HH:mm:ss')
        : moment().add(-1, 'month').format('YYYY-MM-DD HH:mm:ss');
    }
    return user;
  }

  render() {
    const { drivers, isLoading } = this.state;

    const Drivers = [];
    const DriversNewCol = [];

    if (drivers?.length > 0) {
      drivers.forEach((i, j) => {
        if (i?.driver) {
          let dashboardPanelColor = 'bg-pink';
          const jobs = i.driver.jobs;

          if (jobs) {
            const currentDay = moment();
            let fifthAndMoreDay = moment(currentDay).clone().add(4, 'day');
            let forthDay = moment(currentDay).clone().add(3, 'day');
            let dayAfterTommorow = moment(currentDay).clone().add(2, 'day');
            let tommorow = moment(currentDay).clone().add(1, 'day');
            let today = moment(currentDay).clone();

            // Skip weekends.
            [fifthAndMoreDay, forthDay, dayAfterTommorow, tommorow].forEach((day) => {
              while (day.day() === 0 || day.day() === 6) {
                day.add(1, 'day');
              }
            });

            const lastJobOfDriver = _.last(jobs);
            if (!lastJobOfDriver) {
              dashboardPanelColor = 'bg-primary';
            } else {
              const scheduled_dropoff_date = moment(lastJobOfDriver.scheduled_dropoff_date).format('Y-M-D');
              if (moment(scheduled_dropoff_date).isSameOrAfter(fifthAndMoreDay.format('Y-M-D'))) {
                dashboardPanelColor = 'bg-yellow';
              }
              if (moment(scheduled_dropoff_date).isSame(forthDay.format('Y-M-D'))) {
                dashboardPanelColor = 'bg-cyan';
              }
              if (moment(scheduled_dropoff_date).isSame(dayAfterTommorow.format('Y-M-D'))) {
                dashboardPanelColor = 'bg-success';
              }
              if (moment(scheduled_dropoff_date).isSame(tommorow.format('Y-M-D'))) {
                dashboardPanelColor = 'bg-orange';
              }
              if (moment(scheduled_dropoff_date).isSame(today.format('Y-M-D'))) {
                dashboardPanelColor = 'bg-danger';
              }
            }

            if (i?.is_driver_sick) {
              dashboardPanelColor += ' text-decoration-line-through';
            }
          }

          const renderCode = (
            <div key={j} className={`driver-table filter-${i?.company?.shortName?.toLowerCase() || 'default'}`} id={`driver-table-list-${i?.driver?.id}`}>
              <div className="driver-container mb-0">
                <div className={`driver-main-info ${dashboardPanelColor}`}>
                  <div className="row">
                    <div className="col-md-3">
                      <p>{i?.first_name} {i?.last_name}</p>
                    </div>
                    <div className="col-md-3">
                      <p>
                        {jobs?.length > 0 && moment(jobs[jobs.length - 1]?.scheduled_dropoff_date).isValid()
                          ? moment(jobs[jobs.length - 1].scheduled_dropoff_date).format('DD-MM-YYYY, hh:mm:ss')
                          : ''}
                      </p>
                    </div>
                    <div className="col-md-3">
                      <p>{jobs?.[jobs.length - 1]?.dropoff_address?.town_city}</p>
                    </div>
                    {i.driver?.home_address && (
                      <div className="col-md-3">
                        <p><i className="fa fa-home"></i> {i.driver?.home_address?.town_city}</p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          );

          if (j > 40) {
            DriversNewCol.push(renderCode);
          } else {
            Drivers.push(renderCode);
          }
        }
      });
    }

    return (
      <div className="drivers-table">
        <div className="tab-content-container main-tab-content-container">
          {isLoading ? (
            <div className="loading-box">
              <span className="add-loading-text">
                <i className="fa fa-spinner fa-pulse"></i>
              </span>
            </div>
          ) : (
            <div className="row">
              <div className="col-6 no-padding">{Drivers}</div>
              <div className="col-6 no-padding">{DriversNewCol}</div>
            </div>
          )}
        </div>
      </div>
    );
  }
}